import { Button } from "@component/button";
import { MessageSquareIcon, MessageSquareOffIcon } from "lucide-react";

interface TranscriptionToggleButtonProps {
    isOpen: boolean;
    onClick: () => void;
}

export default function TranscriptionToggleButton({
    isOpen,
    onClick,
}: TranscriptionToggleButtonProps) {
    return (
        <Button
            size="icon"
            className={`p-2 md:p-3 rounded-full transition-colors bg-gray-700 hover:${isOpen ? "bg-gray-600" : "bg-blue-600"}`}
            onClick={onClick}
            title={isOpen ? "Hide transcription" : "Show transcription"}
        >
            {isOpen ? (
                <MessageSquareOffIcon className="h-5 w-5" />
            ) : (
                <MessageSquareIcon className="h-5 w-5" />
            )}
            <span className="sr-only">
                {isOpen ? "Hide transcription" : "Show transcription"}
            </span>
        </Button>
    );
}
